export enum ClockInStatusEnum {
  notRequested = 0,
  requested = 1,
  signed = 2,
  rejected = 3,
}
